import { render, staticRenderFns } from "./SoftwareLicenseConfirmation.vue?vue&type=template&id=1bf0a1fe&scoped=true&"
import script from "./SoftwareLicenseConfirmation.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicenseConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLicenseConfirmation.vue?vue&type=style&index=0&id=1bf0a1fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0a1fe",
  null
  
)

export default component.exports